import {
  Box,
  TextField,
  InputLabel,
  Grid,
  Tooltip,
  IconButton,
} from "@mui/material/";
import { useTranslation } from "react-i18next";
import SearchIcon from "@mui/icons-material/Search";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import "../genericModels.css";
import GenericFilterBox from "../common/GenericFilterBox";

export const CarModelFilterAndSearch = (props: any) => {
  let SearchModel = props.SearchModel;
  let dataFormSearchField = props.dataFormSearchField;
  let setDataFormSearchField = props.setDataFormSearchField;
  let resetFormText = props.resetFormText;
  
  const { t } = useTranslation(["operation"]);

  const handleChange = (event: any, type: any) => {
    setDataFormSearchField({
      ...dataFormSearchField,
      [type]: event.target.value,
    });
  };
  const searchModel = (e: any) => {
    e.preventDefault();
    props.setResetFormValue(!props.resetFormValue);
    //  SearchModel();
  };

  return (
    <>
      <Box>
        <form id="idModelForm" onSubmit={(e) => searchModel(e)}>
          <GenericFilterBox
            formId="idModelForm"
            onReset={resetFormText}
            showExtrasFilters={true}
          >
            <Box>
              <TextField
                fullWidth
                label={t("model.descriptionLabel")}
                //placeholder={t("carRange.descriptionLabel")}
                variant="standard"
                id="descr"
                name="descr"
                value={dataFormSearchField.descr}
                onChange={(event: any) => handleChange(event, "descr")}
                inputProps={{
                  pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                  onInput: (event: any) => {
                    if (event.currentTarget.validity.patternMismatch) {
                      event.currentTarget.setCustomValidity(
                        t("vehicle.filterModal.regexMessage")
                      );
                    } else {
                      event.currentTarget.setCustomValidity("");
                    }
                  },
                }}
              />
            </Box>

            <Box>
              <TextField
                fullWidth
                //placeholder={t("carRange.codeLabel")}
                label={t("model.codeLabel")}
                variant="standard"
                id="code"
                name="code"
                value={dataFormSearchField.code}
                onChange={(event: any) => handleChange(event, "code")}
                inputProps={{
                  pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                  onInput: (event: any) => {
                    if (event.currentTarget.validity.patternMismatch) {
                      event.currentTarget.setCustomValidity(
                        t("vehicle.filterModal.regexMessage")
                      );
                    } else {
                      event.currentTarget.setCustomValidity("");
                    }
                  },
                }}
              />
            </Box>

            <Box>
              <TextField
                fullWidth
                //placeholder={t("model.brandDescription")}
                label={t("brand.description")}
                variant="standard"
                id="descrBrand"
                name="descrBrand"
                value={dataFormSearchField.descrBrand}
                onChange={(event: any) => handleChange(event, "descrBrand")}
                inputProps={{
                  pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                  onInput: (event: any) => {
                    if (event.currentTarget.validity.patternMismatch) {
                      event.currentTarget.setCustomValidity(
                        t("vehicle.filterModal.regexMessage")
                      );
                    } else {
                      event.currentTarget.setCustomValidity("");
                    }
                  },
                }}
              />
            </Box>

            <Box>
              <TextField
                fullWidth
                //placeholder={t("model.brandCode")}
                label={t("brand.code")}
                variant="standard"
                id="codeBrand"
                name="codeBrand"
                value={dataFormSearchField.codeBrand}
                onChange={(event: any) => handleChange(event, "codeBrand")}
                inputProps={{
                  pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                  onInput: (event: any) => {
                    if (event.currentTarget.validity.patternMismatch) {
                      event.currentTarget.setCustomValidity(
                        t("vehicle.filterModal.regexMessage")
                      );
                    } else {
                      event.currentTarget.setCustomValidity("");
                    }
                  },
                }}
              />
            </Box>
          </GenericFilterBox>
        </form>
      </Box>
    </>
  );
};
